class Controller  
  @$inject: ["$rootScope", "$scope", "$state", "$stateParams", "toasty", "Device"]  
  levels: [
    "#bf3575", "#bf3575", "#bf3575", "#f57c00",
    "#f57c00", "#f57c00", "#f57c00",
    "#f57c00", "#05adad", "#05adad", "#05adad"
  ]
  constructor: ($rootScope, $scope, $state, $stateParams, toasty, Device)->    
    
    $scope.filter = {}
    $scope.select = ($event, location)->      
      $scope.filter["location.latitude"] = location.latitude
      $scope.filter["location.longitude"] = location.longitude
      
    $scope.updateMap = (filter)=>
      Device.locations(filter).then (locations)=>      
        if locations and locations.length > 0
          results = {}
          total = {lat: 0, lng: 0, cnt: 0}
          angular.forEach locations, (location)->
            {_id:{latitude, longitude, status}, count} = location
            if not latitude or not longitude
              return
            geo = "#{latitude}-#{longitude}"
            if not results[geo]
               results[geo] =
                cnt: 0
                online: 0
                latitude: latitude
                longitude: longitude
            total.lat += latitude
            total.lng += longitude
            total.cnt += count
            if status is 'A'
              results[geo].online +=count
            results[geo].cnt += count
          $scope.markers = []
          angular.forEach results, (result)=>
            scale = 5 + 30 * ((result.cnt/ total.cnt))              
            $scope.markers.push
              id:
                latitude: result.latitude
                longitude: result.longitude
              coords: [result.latitude, result.longitude]
              options:
                icon:
                  path: google.maps.SymbolPath.CIRCLE,
                  fillOpacity: 0.6
                  fillColor: @calculate(result)
                  strokeOpacity: 0
                  scale: scale
          
          $scope.center =
            latitude: total.lat / total.cnt
            longitude: total.lng / total.cnt
    $scope.$watch "filter", (val, org)->
      if org.os isnt val.os or org.status isnt val.status        
        $scope.filter["location.latitude"] = null
        $scope.filter["location.longitude"] = null
      $scope.updateMap val
    , true

      

  calculate: (result)->
    level = ((result.online / result.cnt) * 10).toFixed(0)
    return @levels[level]



module.exports = Controller




// WEBPACK FOOTER //
// ./src/component/dashboard/controller.coffee